// ==============================|| HEADER: SIGNED OUT ||============================== //

// Renders nothing: every page is locked behind login and the login screen is the
// default view, so there's no demo mode to announce and no sign-in button to
// surface (the user is already on /login).
const HeaderSignedOut = () => null;

export default HeaderSignedOut;
